import * as models from './model';

export interface ILink {
    href: string;
    rel: string;
    method: string;
}
